export default "__VITE_ASSET__CzXvPPSU__"